// Тип партнёра (поле partner_type): супервизор работает с данными своих клиентов, реферал только привлекает.
// null у старых записей означает «не классифицирован», это не третий тип.
export const PARTNER_TYPES = {
  SUPERVISOR: 'supervisor',
  REFERRER: 'referrer',
};

export const PARTNER_TYPE_OPTIONS = [
  { value: PARTNER_TYPES.SUPERVISOR, text: 'Супервизор' },
  { value: PARTNER_TYPES.REFERRER, text: 'Реферал' },
];

export const partnerTypeLabel = (type) => {
  const found = PARTNER_TYPE_OPTIONS.find((o) => o.value === type);
  return found ? found.text : '—';
};

export const partnerFullName = (partner) => (partner
  ? [partner.last_name, partner.first_name].filter(Boolean).join(' ') || 'имя не задано'
  : '');

// Привязка корпа приходит числовым ID либо (на всякий случай) вложенным объектом
export const partnerIdOf = (link) => {
  if (link === null || link === undefined || link === '') return null;
  return typeof link === 'object' ? link.id : link;
};

// Поле partner_type может быть ещё не отдано бэком (undefined): тогда считаем партнёра супервизором,
// как было до появления типов. null у старой записи означает «не классифицирован» и не подходит ни под один тип.
export const isPartnerOfType = (partner, type) => partner.partner_type === type
  || (partner.partner_type === undefined && type === PARTNER_TYPES.SUPERVISOR);
